(function(){

    $( "body" ).on( "focusin", ".input-block", function() {
        $( this ).children('input').css( "color", "#4a4a4a" );
        $( this ).children('div').css( "background", "url('/img/svg/" + $( this ).children('input').attr('name') + "-b.svg') no-repeat center center" );
    });

    $( "body" ).on( "focusout", ".input-block", function() {
        if ($(this).children('input').val()) {
            $( this ).children('input').css( "color", "#ffbd4f" );
            $( this ).children('div').css( "background", "url('/img/svg/" + $( this ).children('input').attr('name') + "-y.svg') no-repeat center center" );
        } else {
            $( this ).children('input').css( "color", "#bab9b9" );
            $( this ).children('div').css( "background", "url('/img/svg/" + $( this ).children('input').attr('name') + "-g.svg') no-repeat center center" );
        }
    });

})();
